import Moderator from '@/models/bread/Moderator/item'

export default {
  key:'Item',
  name:{
    singular:'Item',
    plural:'Items',
  },
  parents:[
    //
  ],
  Admin:false,
  Moderator:Moderator,
  Teacher:false,
}